import React, { FC, useEffect, useState } from "react";
import { RentalType } from "../../types";
import { BsThreeDots } from "react-icons/bs";
import RentalHistoryCard from "./RentalHistoryCard";
import { useSelector } from "react-redux";

interface RentalHistoryProps {
  rentals: RentalType[];
  type: "lessee" | "lessor";
}
const RentalHistory: FC = () => {
  const type = useSelector((state: any) => state.dashboardState.dashboardType);
  const lessorRentals: RentalType[] = useSelector(
    (state: any) => state.dashboardState.lessorRentals
  );
  const lesseeRentals: RentalType[] = useSelector(
    (state: any) => state.dashboardState.lesseeRentals
  );

  const [rentals, setRentals] = useState<RentalType[]>([]);

  useEffect(() => {
    if (type === "lessee") {
      setRentals(
        lesseeRentals.filter((rental) => rental.rentalStatus !== "Requesting")
      );
    } else {
      setRentals(
        lessorRentals.filter((rental) => rental.rentalStatus !== "Requesting")
      );
    }
  }, [lesseeRentals, lessorRentals, type]);
  return (
    <div className="bg-white p-5 w-full flex flex-col gap-5">
      <div className="flex items-center justify-between">
        <p className="text-[#3D475C] font-Inter text-[13px] font-medium leading-4">
          {type === "lessee" ? "Rental History" : "Rental Requests"}
        </p>

        <BsThreeDots className="text-[#3D475C]" />
      </div>
      <div className="flex flex-col gap-10 w-full">
        {rentals.length ? (
          rentals.map((rental, index) => (
            <RentalHistoryCard rental={rental} key={index} />
          ))
        ) : (
          <div className="p-20">
            <p className="text-[#3D475C] font-Inter text-[13px] font-medium leading-4">
              No Rentals
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RentalHistory;
